import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import defaultSocialThumb from '../images/social-thumb.jpg';

function SEO({
  description,
  lang,
  meta,
  path,
  canonical,
  keywords,
  title,
  cityLocation,
  socialImage,
}) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description;
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}${
              cityLocation ? ` - ${cityLocation}` : ''
            }`}
            link={
              canonical
                ? [
                    {
                      rel: 'canonical',
                      href: `${data.site.siteMetadata.siteBaseUrl}${canonical}`,
                    },
                  ]
                : []
            }
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:image`,
                content: `${data.site.siteMetadata.siteBaseUrl}${socialImage ||
                  defaultSocialThumb}`,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:url`,
                content: `${data.site.siteMetadata.siteBaseUrl}${
                  path ? path : ''
                }`,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary_large_image`,
              },
              {
                name: `twitter:site`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:image`,
                content: `${data.site.siteMetadata.siteBaseUrl}${socialImage ||
                  defaultSocialThumb}`,
              },
              {
                name: `twitter:image:alt`,
                content: 'Beer Finder logo',
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
          />
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        siteBaseUrl
      }
    }
  }
`;
